import React from 'react'
import { Container, CardMobPreload } from '@rst/ui-ts'
import styled from 'styled-components'

export const CardMob = ({ data }: any) => {
	return (
		<StyledContainer>
			<CardMobPreload {...data} />
		</StyledContainer>
	)
}

const StyledContainer = styled(Container)`
	display: flex;
	flex-direction: column;
	margin: 0;
	width: 100%;
	padding: 32px 0;
`
